<template>
  <div :id="`${id}-aircraft-people-btn`">
    <b-button v-ripple.400 size="sm" variant="light" v-bind="$attrs" v-on="$listeners" @click="click">
      <font-awesome-icon class="mr-50" icon="users" />
      <span> {{ people.passengers ? people.passengers : 0 }} {{ $t('trip.event.pax') }} </span>
      <span class="mx-25"> / </span>
      <span> {{ people.crew ? people.crew : 0 }} {{ $tc('trip.event.crew_number', people.crew ? people.crew : 0) }} </span>
      <font-awesome-icon v-if="showChevron" :icon="chevronDown ? 'chevron-down' : 'chevron-up'" class="ml-50" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'AircraftPeopleBtn',

  props: {
    id: {
      type: String,
      default: 'aircraft-people-btn',
    },
    people: {
      type: Object,
      default: () => ({}),
    },
    showChevron: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chevronDown: false,
    }
  },
  methods: {
    click(e) {
      this.showChevron && (this.chevronDown = !this.chevronDown)
      this.$emit('click', e)
    },
  },
}
</script>
<style lang="scss" scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
